import React from 'react';
import { MdOutlineInfo } from 'react-icons/md';

export default function AlertBox(props: { text: string; className?: string }) {
    return (
        <div
            className={`flex items-center gap-2 rounded border-2 border-red-600 bg-red-200 py-3 px-4 ${props.className}`}>
            <div>
                <MdOutlineInfo className={'text-3xl'} />
            </div>
            <small>{props.text}</small>
        </div>
    );
}
